export default "__VITE_ASSET__BapLDk0r__"